import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RotatingBannerComponent } from './rotating-banner/rotating-banner.component';
import { RouterModule } from '@angular/router';
import { I18nModule, UrlModule, ConfigModule, CmsConfig, AuthGuard } from '@spartacus/core';
import { PageLayoutModule, OutletModule, OutletRefModule, PageSlotModule, AppRoutingModule } from '@spartacus/storefront';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { SecureGuard } from 'src/app/services/Guards/secure.service';



@NgModule({
  declarations: [
    RotatingBannerComponent,
  ],
  imports: [
    CommonModule,
    PageLayoutModule,
    OutletModule,
    OutletRefModule,
    PageSlotModule,
    I18nModule,
    UrlModule,
    RouterModule,
    AppRoutingModule,
    SlickCarouselModule,

    ConfigModule.withConfig({
      cmsComponents: {
        RotatingImagesComponent: {
          component: RotatingBannerComponent,
          guards: [SecureGuard]
        }
      }
    } as CmsConfig)
  ],
})
export class KbRotatingBannerModule {

}
